<template>
    <a href="/" class="w-home-button" 
        :class="{'w-home-button-left': position == 'left'}" 
        :style="{bottom: bottom}">
        <i class="iconfont icon-tabBar"></i>
    </a>
</template>

<script>

export default {
    props: {
        position: {
            type: String,
        },
        bottom: {
            type: String,
        }
    },
};
</script>

<style>
.w-home-button {
    position: fixed;
    right: 15px;
    bottom: 40px;

    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    width: 46px;
    background: #2DB6B4;
    border-radius: 30px;
}
.w-home-button i{
    color: #fff;
    font-size: 22px;
}
.w-home-button-left{
    left: 15px;
}
</style>
